import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

/**
 * 非workbench直接执行，workbench内等待挂载后执行
 * @param callback
 * @returns
 */
export function waitWorkbenchMountHandler(callback: (isInWorkbench: boolean) => void): void {
    const isInWorkbench = document.getElementById('workbench');
    if (!isInWorkbench) {
        callback(false);
        return;
    }
    eventBus.on(EventKeys.WORKBENCH_IS_MOUNT, () => callback(true));
}
